import { useRef, useState } from 'react';
import { Cropper } from 'react-cropper';
import { Button, Checkbox, Dialog } from '@schibsted-svp/react-ui';
import 'cropperjs/dist/cropper.css';

import type { ChangeEvent, FC } from 'react';
import type { ReactCropperElement } from 'react-cropper';

import styles from './ImageCropper.module.scss';

type Props = {
  imageDataUrl?: string | null;
  onCrop: (blob: Blob | null) => Promise<void>;
  onClose: () => void;
  aspectRatio?: number;
  buttonLabel?: string;
};

const ImageCropper: FC<Props> = ({
  imageDataUrl,
  onCrop,
  onClose,
  aspectRatio = 16 / 9,
  buttonLabel = 'Crop',
}) => {
  const cropperRef = useRef<ReactCropperElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPNG, setIsPNG] = useState(false);

  const isOpen = Boolean(imageDataUrl);

  function onButtonClick() {
    cropperRef.current?.cropper.getCroppedCanvas().toBlob(
      async (blob) => {
        setIsSubmitting(true);
        await onCrop(blob);
        setIsSubmitting(false);
        setIsPNG(false);
      },
      isPNG ? 'image/png' : 'image/jpeg'
    );
  }

  return (
    <Dialog heading="Crop image" isOpen={isOpen}>
      <Dialog.Section>
        <Cropper
          src={imageDataUrl ?? undefined}
          ref={cropperRef}
          aspectRatio={aspectRatio}
          autoCrop
          autoCropArea={1}
        />
        <div className={styles.checkbox}>
          <Checkbox
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setIsPNG(event.target.checked)
            }
            checked={isPNG}
            label="Save as PNG"
          />
        </div>
      </Dialog.Section>
      <Dialog.Section variant="darker" mode="flexRight">
        <Button type="button" onClick={onClose} variant="standard">
          Cancel
        </Button>
        <Button type="button" onClick={onButtonClick} loading={isSubmitting}>
          {buttonLabel}
        </Button>
      </Dialog.Section>
    </Dialog>
  );
};

export { ImageCropper };
